export default "__VITE_ASSET__Blv46P8A__"